import React from "react";
import VATNumberValidation from "./VATNumberValidation";
import { Field } from "react-final-form";
import { TextFieldAdapter } from "@soqs/common";

const VATNumberComponent = (props) => {
  let { required, ...rest } = props;
  if (required === undefined) {
    required = true;
  }

  const isValid = (value) =>
    (!required && (!value || value.length === 0)) ||
    (value && VATNumberValidation(value))
      ? undefined
      : "Please enter a valid VAT Number";

  let { name } = props;
  if (name === undefined) {
    name = "taxnumber";
  }

  return (
    <Field
      name={name}
      validate={isValid}
      label="VAT Number"
      required={required}
      component={TextFieldAdapter}
      subscription={{ touched: true, value: true, error: true }}
      inputProps={{ maxLength: 10 }}
      fullWidth
      {...rest}
    />
  );
};

export default VATNumberComponent;
